import VideoEmailCapture from './VideoEmailCapture'

export default VideoEmailCapture
// eslint-disable-next-line import/export
export * from './VideoEmailCapture'
